import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["checkbox", "conditionalFields"]

    connect() {
        this.toggle()
    }

    toggle() {
        const isChecked = this.checkboxTarget.checked
        this.conditionalFieldsTarget.style.display = isChecked ? "" : "none"
    }
}
